import { useEffect } from "react";
import { useLocation } from "react-router-dom";
import useFirebaseAnalytics from "../utils/firebase/hooks/useFirebaseAnalytics";
import { FirebaseEventEnum } from "../utils/firebase/types";
import { useTrackUtmParams } from "./useTrackUtmParams";

export const useNavigateLog = () => {
  useTrackUtmParams();

  const { pathname, search } = useLocation();
  const { LogEvent } = useFirebaseAnalytics();

  useEffect(() => {
    LogEvent(FirebaseEventEnum.PAGE_VIEW, {
      $current_url: window.location.href,
    });
  }, [pathname, search, LogEvent]);
};
